import { render, staticRenderFns } from "./Ending.vue?vue&type=template&id=712d7c14&"
import script from "./Ending.vue?vue&type=script&lang=js&"
export * from "./Ending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports